document.addEventListener('DOMContentLoaded', () => {
  const allDropdowns = document.querySelectorAll('.js-dropdown');
  let ignoreNextFocus = false;

  document.addEventListener('mousedown', () => {
    ignoreNextFocus = true;
    setTimeout(() => ignoreNextFocus = false, 100);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-open-dropdown');
    const link = event.target.closest('.js-dropdown a');

    if (!button && !link && !event.target.closest('.js-dropdown')) {
      allDropdowns.forEach(d => d.classList.remove('active'));
      return;
    }

    if (button) {
      toggleDropdown(button);
      return;
    }

    if (link) {
      const dropdown = link.closest('.js-dropdown');
      const allLinks = dropdown.querySelectorAll('a');
      allLinks.forEach(a => a.classList.remove('active'));
      link.classList.add('active');

      const parent = dropdown.parentElement;
      const toggle = parent.querySelector('.js-open-dropdown span');

      if (toggle) {
        toggle.textContent = link.textContent.trim();
      }

      dropdown.classList.remove('active');

      event.preventDefault();
      return;
    }
  });

  document.addEventListener('focusin', (event) => {
    if (ignoreNextFocus) return;
    const button = event.target.closest('.js-open-dropdown');
    if (button) toggleDropdown(button);
  });

  function toggleDropdown(button) {
    const parent = button.parentElement;
    if (!parent) return;

    const dropdown = parent.querySelector('.js-dropdown');
    if (!dropdown) return;

    const isActive = dropdown.classList.contains('active');
    allDropdowns.forEach(d => d.classList.remove('active'));

    if (!isActive) dropdown.classList.add('active');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  const textarea = form.querySelector('textarea');
  if (!textarea) return;

  const button = form.querySelector('.button');
  if (!button) return;

  button.addEventListener('click', () => {
    const activeTopic = document.querySelector('.js-dropdown-topic.active');
    if (!activeTopic) return;

    const topicText = (activeTopic.dataset.topic || activeTopic.textContent || '').trim();
    if (!topicText) return;

    const prefix = `Temat rozmowy: ${topicText}\n\n`;

    const hasTopic = textarea.value.startsWith('Temat rozmowy:');

    if (!hasTopic) {
      textarea.value = prefix + textarea.value;
    }
  });
});